import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=d09adc34"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/home/node/app/components/ui/uiInput.vue').default,Search: require('/home/node/app/assets/icons/search.vue').default,ControllerSearch: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerSearch.js').default,Btn: require('/home/node/app/components/ui/btn.vue').default,ControllerError: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerError.js').default})
